import { rootRoute } from "@/routing/routes";
import { createRoute } from "@tanstack/react-router";
import { EmergentSignInPage } from ".";

const index = createRoute({
  path: "emergent-signin",
  getParentRoute: () => rootRoute,
  component: EmergentSignInPage,
});

export const emergentSignInRoutes = index;
